import React from 'react';
import { testimonials } from '../data/teatro';
export function Testimonials() {
  // Nascosta finché non ci sono recensioni autentiche di TEATRO PRONTO in data/teatro.ts
  if (testimonials.length === 0) return null;
  return <section className="w-full border-t border-slate-900/10 bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-283" data-mp="3fycqdmmec5as">
      <div className="mx-auto max-w-6xl" data-id="element-284" data-mp="3azt41l3w4rhw">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-285" data-mp="36yzfcpimj8ny">
          Cosa dicono gli <em className="text-red-700" data-id="element-286" data-mp="31zd1qeyvvqem">insegnanti</em>
        </h2>

        <div className="mt-14 grid gap-10 border-t border-slate-900/15 pt-10 sm:grid-cols-3" data-id="element-287" data-mp="3228za26tkd2j">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col" data-id="element-288" data-mp="2s1ymujslz9of">
              <div className="text-sm text-amber-500" aria-label="5 stelle su 5" data-id="element-289" data-mp="2s3t5frgeqppc">
                <span aria-hidden="true" data-id="element-290" data-mp="v8ncpcxfipjo">★★★★★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-serif text-2xl leading-snug text-slate-900" data-id="element-291" data-mp="qbevbek3upjh">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-6 text-sm" data-id="element-292" data-mp="m51cjvsy5da0">
                <span className="font-semibold text-slate-900" data-id="element-293" data-mp="m5sxmcox3sm1">{item.name}</span>
                <span className="text-slate-900/60" data-id="element-294" data-mp="78jzn053zqlc"> — {item.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}